module.exports = __webpack_public_path__ + "media/images/pc/stores/suns/magazine/day02_07_stay-56e61408dd382c4c0f56d65cf6da2475.jpg";